import LegalLink from '@/components/legalLinks/components/legalLink';
import { type Brand } from '@/consts/brands';
import { urls } from '@/utils/urls';

const TermsOfService = ({ brand }: { brand: Brand }) => {
  return (
    <LegalLink
      dataTestId="terms-of-service"
      title="Terms of Service"
      src={urls[brand].site.legal.terms}
      type="TermsOfService"
    />
  );
};

export default TermsOfService;
